import React from 'react';
import { Link } from 'react-router-dom';

interface Props {
  mode: 'signup' | 'login';
  checked: boolean;
  onChange: (v: boolean) => void;
  /** true after they tried to continue without ticking the box */
  invalid: boolean;
}

// Sign-up: a required "I'm 18 or older" checkbox. Sign-in: a one-line notice
// (a brand-new Google user can arrive through either button).
export default function AgeConsent({ mode, checked, onChange, invalid }: Props) {
  const links = (
    <>
      <Link to="/terms" target="_blank" className="underline underline-offset-2" style={{ color: 'inherit' }}>Terms</Link>
      {' and '}
      <Link to="/privacy" target="_blank" className="underline underline-offset-2" style={{ color: 'inherit' }}>Privacy Policy</Link>
    </>
  );

  if (mode === 'login') {
    return (
      <p className="text-xs text-zinc-500 leading-relaxed text-center">
        By continuing, you confirm you're 18 or older and agree to our {links}.
      </p>
    );
  }

  return (
    <div>
      <label
        className="flex items-start gap-3 cursor-pointer rounded-xl p-3 border transition-colors"
        style={{
          borderColor: invalid && !checked ? '#e11d48' : 'var(--color-brand-border)',
          background: invalid && !checked ? 'rgba(225,29,72,0.06)' : 'transparent',
        }}
      >
        <input
          type="checkbox"
          checked={checked}
          onChange={e => onChange(e.target.checked)}
          style={{ width: 20, height: 20, marginTop: 1, accentColor: '#e11d48', flexShrink: 0 }}
        />
        <span className="text-sm leading-snug" style={{ color: 'var(--color-brand-text)' }}>
          I'm 18 or older, and I agree to the {links}.
        </span>
      </label>
      {invalid && !checked && (
        <p className="text-rose-400 text-sm mt-2">Please confirm you're 18 or older to continue.</p>
      )}
    </div>
  );
}
